export const env_uat = {
    BASE_URL: 'https://equipajes-uat.europ20.es',
    NODE_ENV: 'uat',
}